module.exports = __webpack_public_path__ + "img/t2-c1.d4913ca2.png";